export type StatusItemType = {
  classColor?: string
  description: string
  group: number
  title: string
}
const statuses: StatusItemType[] = [
  {
    classColor: 'green',
    description:
      'Ihre Bestellung wird innerhalb von 24 Stunden unser Lager verlassen.',
    group: 1,
    title: 'Versandbereit',
  },
  {
    classColor: 'green',
    description: 'Ihre Bestellung wir in 2-3 Tagen versandbereit sein.',
    group: 1,
    title: 'Versand in 2-3 Tagen',
  },
  {
    classColor: 'green',
    description: 'Ihre Bestellung wir unser Lager in 4-6 Tagen verlassen.',
    group: 1,
    title: 'Versand in 4-6 Tagen',
  },
  {
    classColor: 'green',
    description:
      'Überprüfen Sie, ob Ihre Bestellung für eine NOW-Lieferung geeignet ist.',
    group: 1,
    title: 'NOW! Verfügbar',
  },
  {
    classColor: 'green',
    description:
      'Ihr Artikel wird so schnell wie möglich aus unserem Lager versendet.',
    group: 1,
    title: 'Lieferbar',
  },
  {
    classColor: 'yellow',
    description:
      'Dieses Produkt befindet sich derzeit bei einem Distributor, was zu einer leichten Verlängerung der Bearbeitungszeit Ihrer Bestellung führt.',
    group: 2,
    title: 'Versand bei Wareneingang',
  },
  {
    classColor: 'red',
    description:
      'Leider ist dieser Artikel momentan nicht beim Großhändler oder Hersteller verfügbar. Bitte hinterlassen Sie Ihre E-Mail-Adresse, und wir benachrichtigen Sie, sobald das Produkt wieder verfügbar ist.',
    group: 2,
    title: 'Produkt vorübergehend nicht lieferbar',
  },
]

export { statuses }
